import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { arrayOf, func, number, object, oneOfType, shape, string } from 'prop-types';
import { useStyle } from '@magento/venia-ui/lib/classify'; //'../../classify';

import getOptionType from './getOptionType';
import SwatchList from './swatchList';
import TileList from './tileList';
import defaultClasses from './option.module.css';
import { useOption } from '@magento/peregrine/lib/talons/ProductOptions/useOption';
import Trigger from '@magento/venia-ui/lib/components/Trigger'; // import { useDrawer } from '../ProductFullDetail/hooks/useDrawer';

import { Button, CloseIcon } from '../../../../components'; //'../../../';

import { useClickOutside } from '../../../../Utils/utils';
import { addScrollToBody, removeScrollFromBody } from '../../../../hooks/utils';

var getItemKey = function getItemKey(_ref) {
  var value_index = _ref.value_index;
  return value_index;
}; // TODO: get an explicit field from the API
// that identifies an attribute as a swatch


var getListComponent = function getListComponent(attribute_code, values) {
  var optionType = getOptionType({
    attribute_code: attribute_code,
    values: values
  });
  return optionType === 'swatch' ? SwatchList : TileList;
};

var Option = function Option(props) {
  var _values$find, _selectedValue$swatch, _values$find2, _values$find2$swatch_, _initialSelection$swa;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      selectModal = _useState2[0],
      setSelectModal = _useState2[1];

  var attribute_code = props.attribute_code,
      attribute_id = props.attribute_id,
      label = props.label,
      onSelectionChange = props.onSelectionChange,
      selectedValue = props.selectedValue,
      values = props.values,
      defaultOptionValue = props.defaultOptionValue,
      disabledValuesMap = props.disabledValuesMap,
      isReset = props.isReset;
  useEffect(function () {
    if (!selectModal) addScrollToBody(false);else removeScrollFromBody(false, "scroll-swatch-".concat(attribute_id));
    return function () {
      return addScrollToBody(false);
    };
  }, [selectModal, attribute_id]);
  var talonProps = useOption({
    attribute_id: attribute_id,
    label: label,
    onSelectionChange: onSelectionChange,
    selectedValue: selectedValue,
    values: values
  });
  var handleSelectionChange = talonProps.handleSelectionChange,
      initialSelection = talonProps.initialSelection,
      selectedValueDescription = talonProps.selectedValueDescription;
  var classes = useStyle(defaultClasses, props.classes);
  var derivedInitialSelection = !!selectedValue ? selectedValue : Object.keys(initialSelection).length === 0 || isReset ? values.find(function (value) {
    return value.value_index == defaultOptionValue;
  }) : initialSelection;
  var derivedSelectedValueDescription = !!selectedValue ? selectedValue.store_label : Object.keys(initialSelection).length === 0 || isReset ? (_values$find = values.find(function (value) {
    return value.value_index == defaultOptionValue;
  })) === null || _values$find === void 0 ? void 0 : _values$find.store_label : selectedValueDescription;
  var derivedSelectedValueSwatch = !!selectedValue ? (_selectedValue$swatch = selectedValue.swatch_data) === null || _selectedValue$swatch === void 0 ? void 0 : _selectedValue$swatch.thumbnail : Object.keys(initialSelection).length === 0 || isReset ? (_values$find2 = values.find(function (value) {
    return value.value_index == defaultOptionValue;
  })) === null || _values$find2 === void 0 ? void 0 : (_values$find2$swatch_ = _values$find2.swatch_data) === null || _values$find2$swatch_ === void 0 ? void 0 : _values$find2$swatch_.thumbnail : (_initialSelection$swa = initialSelection.swatch_data) === null || _initialSelection$swa === void 0 ? void 0 : _initialSelection$swa.thumbnail;

  var openSelectModal = function openSelectModal() {
    if (values.length > 1) setSelectModal(true);
  };

  var closeSelection = function closeSelection() {
    return setSelectModal(false);
  };

  var optionRef = useClickOutside(closeSelection);
  var drawerClasses = selectModal ? classes.drawerWrapper_Active : classes.drawerWrapper;
  return React.createElement("div", {
    ref: optionRef
  }, React.createElement(Trigger, {
    classes: {
      root: 'span-col-1 bg-snowbound flex xl_flex-row flex-col xl_gap-0 w-full h-full'
    },
    action: function action() {
      openSelectModal();
      removeScrollFromBody(false, "scroll-swatch-".concat(attribute_id));
    },
    disabled: (values === null || values === void 0 ? void 0 : values.length) < 2,
    "aria-label": "Change"
  }, derivedSelectedValueSwatch && React.createElement("div", {
    className: classes.optionImage
  }, React.createElement("img", {
    src: derivedSelectedValueSwatch,
    alt: "select options image",
    className: "w-full md_h-full"
  })), React.createElement("div", {
    className: "ml-2 py-3"
  }, React.createElement("h6", {
    className: "text-black text-left font-bold leading-129"
  }, label), React.createElement("p", {
    className: classes.selectedOptionValue + ' text-bronze text-sm text-left'
  }, derivedSelectedValueDescription), (values === null || values === void 0 ? void 0 : values.length) > 1 && React.createElement("p", {
    className: "underline uppercase text-bronze font-bold text-left"
  }, "Change"))), React.createElement("div", {
    className: drawerClasses
  }, React.createElement("div", {
    className: classes.drawerContent
  }, React.createElement("div", {
    className: classes.drawerHeader + ' py-10'
  }, React.createElement("h5", {
    className: "text-white text-h5 leading-156"
  }, "Select ", label), React.createElement("div", {
    onClick: closeSelection,
    className: classes.closeWrapper,
    role: "button"
  }, React.createElement(CloseIcon, null))), React.createElement("p", {
    className: "text-base mt-6 text-center text-bronze w-full"
  }, "Click to Select ", label), React.createElement("div", {
    className: classes.body
  }, React.createElement(SwatchList, {
    getItemKey: getItemKey // selectedValue={initialSelection}
    ,
    selectedValue: derivedInitialSelection,
    items: values,
    onSelectionChange: handleSelectionChange,
    disabledValuesMap: disabledValuesMap,
    attribute_id: attribute_id,
    defaultValue: values.find(function (value) {
      return value.value_index == defaultOptionValue;
    })
  }), React.createElement("div", {
    className: "mb-4"
  }, React.createElement(Button, {
    priority: "low",
    "aria-label": "Confirm selection",
    onClick: closeSelection,
    fullWidth: true,
    classes: {
      content: classes.btn
    }
  }, "CONFIRM SELECTION"))))));
};

Option.propTypes = {
  attribute_code: string.isRequired,
  attribute_id: string,
  classes: shape({
    root: string,
    title: string
  }),
  label: string.isRequired,
  onSelectionChange: func,
  selectedValue: oneOfType([number, string, object]),
  values: arrayOf(object).isRequired
};
export default Option;